export const findNotesInBin = (bin, id) => {
    return bin.some(note => note.id === id);
}